<!-- 连连支付的收款mock页面 -->
<template>
  <div class="container">
    <div>
      <van-row>
        <van-col span="12" class="mt-5 font-title">
          <span>交易信息</span>
        </van-col>
        <van-col span="3" offset="9">
          <span style="color: green">详情</span>
        </van-col>
      </van-row>
      <van-row class="mt-5">
        <van-col span="12">
          <span>应付金额</span>
        </van-col>
        <van-col span="3" offset="9">100元</van-col>
      </van-row>
      <van-row>
        <van-col span="12" class="mt-10 font-title">
          <span>新认证支付</span>
        </van-col>
      </van-row>
      <van-row>
        <van-col span="24" class="mt-10">
          <span style="color: gray">
            当前操作需要验证短信验证码，请输入如下手机号收到的6位短信验证码
          </span>
        </van-col>
      </van-row>
      <van-row>
        <van-col span="24" class="mt-10">
          <span style="color: gray">18798624470</span>
        </van-col>
      </van-row>
      <van-row class="mt-10">
        <van-cell class="verify_code" center>
          <template #title>
            <van-field
              maxlength="6"
              v-model="code"
              class="code-field"
              placeholder="请输入6位验证码" />
          </template>
          <template #right-icon>
            <span style="color: green; margin-left: 10px">获取验证码</span>
          </template>
        </van-cell>
      </van-row>
      <van-row type="flex" justify="center" class="mt-15">
        <van-button
          @click="confirmPayment"
          :disabled="this.code.length < 6"
          type="primary"
          style="width: 100%; height: 50px">
          确认支付
        </van-button>
      </van-row>
    </div>

    <div class="footer">
      <span class="corlor:gray">连连银通电子支付有限公司版权所有</span>
    </div>
  </div>
</template>

<script>
import { Row, Col, Cell, Field, Button } from "vant"
export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Cell.name]: Cell,
    [Field.name]: Field,
    [Button.name]: Button
  },
  name: "LianLianPay",
  data() {
    return {
      code: ""
    }
  },
  mounted() {
    document.title = "模拟收银台"
    console.log("路由查询参数:%O", this.$route.query)
  },
  methods: {
    confirmPayment() {
      this.$router.replace({
        path: "/mpayweb/payresult",
        query: {
          backUrl: this.$route.query.url_return,
          notifyUrl: this.$route.query.notify_url,
          orderNo: this.$route.query.order_no,
          result: this.$route.query.result_pay,
        }
      })
    }
  }
}
</script>

<style lang="less">
.container {
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 10px;

  .font-title {
    font-size: 15px;
    font-weight: bold;
  }

  .verify_code {
    border-radius: 5px;
    border: solid 0.5px rgb(210, 207, 207);
  }
  .code-field {
    border-right: solid 0.5px rgb(210, 207, 207);
  }
  .footer {
    width: 100%;
    height: 60px;
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    bottom: 30px;
    left: 0;
    border-top: solid 0.5px rgb(210, 207, 207);
  }
}
</style>